import { Download, FileText } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { useSeo } from "@/components/site/Seo";
import { assetUrl } from "@/lib/api";

export default function MediaKit() {
  const { content } = useSite();
  const m = content.mediakit;
  useSeo("mediakit");
  const url = assetUrl(m.pdf);
  const dl = url ? `${url}${url.includes("?") ? "&" : "?"}download=1` : "";
  const cover = assetUrl(m.cover);
  return (
    <div className="font-arial-all" data-testid="media-kit-page">
      <section className="max-w-[1180px] mx-auto px-6 py-12 sm:py-16 flex justify-center">
        {cover ? (
          dl ? (
            <a href={dl} className="block group" data-testid="media-kit-cover-link">
              <img src={cover} alt="ISD Media Kit cover" className="w-full max-w-[560px] h-auto shadow-2xl transition-transform duration-300 group-hover:-translate-y-1" data-testid="media-kit-cover" />
            </a>
          ) : (
            <img src={cover} alt="ISD Media Kit cover" className="w-full max-w-[560px] h-auto shadow-2xl" data-testid="media-kit-cover" />
          )
        ) : (
          <FileText className="h-16 w-16 text-brass" />
        )}
      </section>
      {!dl && <p className="pb-10 px-6 text-center text-charcoal/70" data-testid="media-kit-empty">{m.empty}</p>}
      <section className="bg-charcoal text-white" data-testid="media-kit-cta">
        <div className="max-w-[1180px] mx-auto px-6 py-14 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl sm:text-3xl font-bold">{m.cta_title}</h2>
            <p className="mt-2 text-white/70 text-sm">{m.cta_text}</p>
          </div>
          {dl && <a href={dl} className="inline-flex items-center gap-2 rounded-full bg-brand hover:bg-brand-dark px-6 py-3 text-sm font-bold transition-colors shrink-0" data-testid="media-kit-download-button"><Download className="h-4 w-4" />{m.button}</a>}
        </div>
      </section>
      {dl && (
        <a href={dl} className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 rounded-full bg-brand hover:bg-brand-dark text-white px-5 py-3 text-sm font-bold shadow-2xl transition-colors" data-testid="media-kit-floating-download">
          <Download className="h-4 w-4" />{m.button}
        </a>
      )}
    </div>
  );
}
